
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import ExpandIcon from "@/components/utils/ExpandIcon.vue";

import "@/store/modules/forms/form8";
const form8State = namespace("Form8");

import "@/store/modules/forms/form9";
const form9State = namespace("Form9");

import "@/store/modules/forms/form22";
const form22State = namespace("Form22");

import Rule20ApplicationInstructions from "./components/Rule20ApplicationInstructions.vue";
import Rule54ApplicationInstructions from "./components/Rule54ApplicationInstructions.vue";
import Rule57ApplicationInstructions from "./components/Rule57ApplicationInstructions.vue";
import Rule58ApplicationInstructions from "./components/Rule58ApplicationInstructions.vue";
import Rule59ApplicationInstructions from "./components/Rule59ApplicationInstructions.vue";
import Rule60ApplicationInstructions from "./components/Rule60ApplicationInstructions.vue";
import Rule61ApplicationInstructions from "./components/Rule61ApplicationInstructions.vue";
import Rule62ApplicationInstructions from "./components/Rule62ApplicationInstructions.vue";
import Rule63ApplicationInstructions from "./components/Rule63ApplicationInstructions.vue";
import Rule54ResponseInstructions from "./components/Rule54ResponseInstructions.vue";
import Rule58ResponseInstructions from "./components/Rule58ResponseInstructions.vue";
import Rule59ResponseInstructions from "./components/Rule59ResponseInstructions.vue";
import Rule60ResponseInstructions from "./components/Rule60ResponseInstructions.vue";
import Rule61ResponseInstructions from "./components/Rule61ResponseInstructions.vue";
import Rule63ResponseInstructions from "./components/Rule63ResponseInstructions.vue";

import {GetInstructionFile} from '@/components/utils/GetInstructionFile';

@Component({
    components:{
        ExpandIcon,
        Rule20ApplicationInstructions,
        Rule54ApplicationInstructions,
        Rule57ApplicationInstructions,
        Rule58ApplicationInstructions,
        Rule59ApplicationInstructions,
        Rule60ApplicationInstructions,
        Rule61ApplicationInstructions,
        Rule62ApplicationInstructions,
        Rule63ApplicationInstructions,
        Rule54ResponseInstructions,
        Rule58ResponseInstructions,
        Rule59ResponseInstructions,
        Rule60ResponseInstructions,
        Rule61ResponseInstructions,
        Rule63ResponseInstructions
    }
})
export default class ManagingAppealProcessPg extends Vue {  

    @form8State.Action
    public UpdateCurrentNoticeOfApplicationToVaryId!: (newCurrentNoticeOfApplicationToVaryId: string) => void

    @form9State.Action
    public UpdateCurrentRequisitionId!: (newCurrentRequisitionId: string) => void

    @form22State.Action
    public UpdateCurrentNoFeesPayableId!: (newCurrentNoFeesPayableId: string) => void

    applicationsList = [
        {text: 'adjournment', value:'adjournment'},
        {text: 'adducing fresh or new evidence', value:'adducing'},
        {text: 'to consolidate or have appeals heard together', value:'consolidate'},
        {text: 'directions', value:'directions'},
        {text: 'dismissal of appeal in chambers', value:'dismissalChambers'},
        {text: 'dismissal (other)', value:'dismissalOther'},
        {text: 'extend time to file books or documents', value:'extendOther'},
        {text: 'extend time to appeal or cross-appeal', value:'extendCrossAppeal'},
        {text: 'intervener status', value:'intervener'},       
        {text: 'payment of security', value:'security'},
        {text: 'quashing an appeal or raising a preliminary objection', value:'objection'},
        {text: 'reinstate appeal that is dismissed as abandoned', value:'reinstate'},
        {text: 'remove appeal from the inactive list', value:'remove'},       
        {text: 'varying or cancelling an order of the registrar', value:'varying'},
        {text: 'other', value:'other'}
    ]

    responsesList = [
        {text: 'adjournment', value:'adjournment'},
        {text: 'adducing fresh or new evidence', value:'adducing'},
        {text: 'to consolidate or have appeals heard together', value:'consolidate'},
        {text: 'directions', value:'directions'},
        {text: 'dismissal of appeal in chambers', value:'dismissalChambers'},
        {text: 'dismissal (other)', value:'dismissalOther'},
        {text: 'extend time to file books or documents', value:'extendOther'},
        {text: 'extend time to appeal or cross-appeal', value:'extendCrossAppeal'},
        {text: 'intervener status', value:'intervener'},       
        {text: 'payment of security', value:'security'},
        {text: 'quashing an appeal or raising a preliminary objection', value:'objection'},
        {text: 'reinstate appeal that is dismissed as abandoned', value:'reinstate'},
        {text: 'remove appeal from the inactive list', value:'remove'},       
        {text: 'varying or cancelling an order of the registrar', value:'varying'},
        {text: 'other', value:'other'}
    ]

    showAppIntroInfo = true;
    showUrgentInfo = false;     
    showStayApplicationsInfo = false;
    showRespIntroInfo = false;
    showForm8Info = false; 
    showForm22Info = false;
    showForm9Info = false;  
    showRespNoaLeaveInfo = false;    
    showRespNoaLeaveStayInfo = false;
    showRespVaryOrderInfo = false;
    showOrderInfo = false;
    affidavit = false;
    applications = [];
    responses = [];
    updatedApps = 0;
    updatedResps = 0;
    appStepsLength = 33;
    respStepsLength = 16;
    appUrgentSectionClass = '';
    appUrgentSectionStyle = '';
    Rule54 = [
        'adjournment', 'consolidate', 'directions', 'dismissalChambers', 
        'dismissalOther', 'extendOther', 'extendCrossAppeal', 
        'reinstate', 'remove', 'other'];
    Rule58 = ['security'];
    Rule59 = ['adducing'];
    Rule60 = ['objection'];
    Rule61 = ['intervener'];
    Rule63 = ['varying'];

    form4Button = 0;

    mounted(){
        this.affidavit = false;
        this.appStepsLength = 33;
        this.respStepsLength = 31;
    }

    public updateApps(){          
        this.appStepsLength = 33;
        this.form4Button = 0;

        if (this.getAppRules().includes('54')){
            this.appStepsLength = this.appStepsLength + 28.5;
            if (this.form4Button == 0){
                this.form4Button = 54;
            }
        }

        if (this.getAppRules().includes('58')){
            this.appStepsLength = this.appStepsLength + 37;
            if (this.form4Button == 0){
                this.form4Button = 58;
            }
        }

        if (this.getAppRules().includes('59')){
            this.appStepsLength = this.appStepsLength + 30;
            if (this.form4Button == 0){
                this.form4Button = 59;
            }
        }

        if (this.getAppRules().includes('60')){
            this.appStepsLength = this.appStepsLength + 40.75;
            if (this.form4Button == 0){
                this.form4Button = 60;
            }
        }

        if (this.getAppRules().includes('61')){
            this.appStepsLength = this.appStepsLength + 29.5;
            if (this.form4Button == 0){
                this.form4Button = 61;
            }
        }      

        if (this.getAppRules().includes('63')){
            this.appStepsLength = this.appStepsLength + 29.5;
            if (this.form4Button == 0){
                this.form4Button = 63;
            }
        }

        if (this.getAppRules().length == 2){
            this.appStepsLength = this.appStepsLength - 4;            
        }

        if (this.getAppRules().length == 3){
            this.appStepsLength = this.appStepsLength - 7;            
        }

        if (this.getAppRules().length == 4){
            this.appStepsLength = this.appStepsLength - 10;            
        }

        if (this.getAppRules().length == 5){
            this.appStepsLength = this.appStepsLength - 15;            
        }

        if (this.getAppRules().length == 6){
            this.appStepsLength = this.appStepsLength - 18;            
        }

        if (this.showAppIntroInfo){
            this.$emit('adjustHeights', 0, this.appStepsLength + "rem");
        }            
        
        this.updatedApps ++; 
    }

    public updateResp(){   

        this.respStepsLength = 31;

        if (this.getRespRules().includes('54')){
            this.respStepsLength = this.respStepsLength + 22;
        }

        if (this.getRespRules().includes('58')){
            this.respStepsLength = this.respStepsLength + 28;
        }

        if (this.getRespRules().includes('59')){
            this.respStepsLength = this.respStepsLength + 29;
        }

        if (this.getRespRules().includes('60')){
            this.respStepsLength = this.respStepsLength + 29;
        }
        
        if (this.getRespRules().includes('61')){
            this.respStepsLength = this.respStepsLength + 25;            
        }  

        if (this.getRespRules().includes('63')){
            this.respStepsLength = this.respStepsLength + 26;
        }

        if (this.getRespRules().length == 2){
            this.respStepsLength = this.respStepsLength - 1;            
        }

        if (this.getRespRules().length == 3){
            this.respStepsLength = this.respStepsLength - 2;            
        }

        if (this.getRespRules().length == 4){
            this.respStepsLength = this.respStepsLength - 3;            
        }

        if (this.getRespRules().length == 5){
            this.respStepsLength = this.respStepsLength - 5;            
        }

        if (this.getRespRules().length == 6){
            this.respStepsLength = this.respStepsLength - 6;            
        }


        if (this.showRespIntroInfo){
            this.$emit('adjustHeights', 3, this.respStepsLength + "rem");
        }            
        
        this.updatedResps ++; 
    }

    public getAppRules(){

        const rules = [];

        if (this.applications.some(app => this.Rule54.includes(app))){
            rules.push('54');
        }

        if (this.applications.some(app => this.Rule58.includes(app))){
            rules.push('58');
        }

        if (this.applications.some(app => this.Rule59.includes(app))){
            rules.push('59');
        }

        if (this.applications.some(app => this.Rule60.includes(app))){
            rules.push('60');
        }

        if (this.applications.some(app => this.Rule61.includes(app))){
            rules.push('61');
        }

        if (this.applications.some(app => this.Rule63.includes(app))){
            rules.push('63');
        }

        return rules;

    }

    public getRespRules(){

        const rules = [];

        if (this.responses.some(app => this.Rule54.includes(app))){
            rules.push('54');
        }

        if (this.responses.some(app => this.Rule58.includes(app))){
            rules.push('58');
        }

        if (this.responses.some(app => this.Rule59.includes(app))){
            rules.push('59');
        }

        if (this.responses.some(app => this.Rule60.includes(app))){
            rules.push('60');
        }

        if (this.responses.some(app => this.Rule61.includes(app))){
            rules.push('61');
        }

        if (this.responses.some(app => this.Rule63.includes(app))){
            rules.push('63');
        }

        return rules;

    }
    
    public showAppIntro(show: boolean){
        if (show) {
            this.showAppIntroInfo = true;
            this.$emit('adjustHeights', 0, this.appStepsLength + "rem");
        } else {
            this.showAppIntroInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    } 
    
    public showUrgent(show: boolean){
        if (show) {
            this.showUrgentInfo = true;
            this.$emit('adjustHeights', 1, "23rem");
        } else {
            this.showUrgentInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    } 

    public showStayApplications(show: boolean){
        if (show) {
            this.showStayApplicationsInfo = true;
            this.$emit('adjustHeights', 2, "30.5rem");
        } else {
            this.showStayApplicationsInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    } 

    public showRespIntro(show: boolean){
        if (show) {
            this.showRespIntroInfo = true;
            this.$emit('adjustHeights', 3, this.respStepsLength + "rem");
        } else {
            this.showRespIntroInfo = false;
            this.$emit('adjustHeights', 3, "0");
        }
    } 
    
    public showForm8(show: boolean){
        if (show) {
            this.showForm8Info = true;
            this.$emit('adjustHeights', 4, "39.5rem");
        } else {
            this.showForm8Info = false;
            this.$emit('adjustHeights', 4, "0");
        }
    }  
    
    public showForm22(show: boolean){
        if (show) {
            this.showForm22Info = true;
            this.$emit('adjustHeights', 5, "17rem");
        } else {
            this.showForm22Info = false;
            this.$emit('adjustHeights', 5, "0");
        }
    }

    public showForm9(show: boolean){
        if (show) {
            this.showForm9Info = true;
            this.$emit('adjustHeights', 6, "44rem");
        } else {
            this.showForm9Info = false;
            this.$emit('adjustHeights', 6, "0");
        }
    }

    public showRespNoaLeave(show: boolean){
       
       if (show) {
           this.showRespNoaLeaveInfo = true;
           this.$emit('adjustHeights', 7, "27rem");
       } else {
           this.showRespNoaLeaveInfo = false;
           this.$emit('adjustHeights', 7, "0");
       }
    }

    public showRespNoaLeaveStay(show: boolean){
       if (show) {
           this.showRespNoaLeaveStayInfo = true;
           this.$emit('adjustHeights', 8, "29rem");
       } else {
           this.showRespNoaLeaveStayInfo = false;
           this.$emit('adjustHeights', 8, "0");
       }
    }

    public showRespVaryOrder(show: boolean){
        if (show) {
            this.showRespVaryOrderInfo = true;
            this.$emit('adjustHeights', 9, "27.5rem");
        } else {
            this.showRespVaryOrderInfo = false;
            this.$emit('adjustHeights', 9, "0");
        }
    }

    public showOrder(show: boolean){
        if (show) {
            this.showOrderInfo = true;
            this.$emit('adjustHeights', 10, "7rem")
        } else {
            this.showOrderInfo = false;
            this.$emit('adjustHeights', 10, "0");
        }
    }
    
    public startNewForm8Document(){
        this.UpdateCurrentNoticeOfApplicationToVaryId(null);
        this.$router.push({name: "start-form8" })
    }

    public startNewForm22Document(){        
        this.UpdateCurrentNoFeesPayableId(null);
        this.$router.push({name: "start-form22" })
    }

    public startNewForm9Document(){
        this.UpdateCurrentRequisitionId(null);
        this.$router.push({name: "start-form9" })
    }

    public downloadInstructions(file_name: string){
        GetInstructionFile(file_name);
    }
    
}
